import { Button } from '@/components/ui/button';
import { TutorialAnchor } from '@/features/session-tutorial/TutorialAnchor';
import { useTutorialStepAction } from '@/features/session-tutorial/useTutorialStepAction';
import { cn } from '@/lib/utils';
import { Mic } from 'lucide-react';

interface RecordingEmptyStateProps {
  onStart: () => void;
  desktopPrompt: string;
  disabled?: boolean;
  disabledReason?: string;
  className?: string;
}

export const RecordingEmptyState = ({
  onStart,
  desktopPrompt,
  disabled = false,
  disabledReason,
  className,
}: RecordingEmptyStateProps) => {
  const handleStart = useTutorialStepAction('mobileRecord', onStart);

  return (
    <TutorialAnchor step="listening">
      <div className={cn('flex h-full flex-col items-center justify-center p-8 text-center text-slate-400', className)}>
        <div data-mobile-recording-start className="flex flex-col items-center gap-3 md:hidden">
          <TutorialAnchor step="mobileRecord">
            <Button
              type="button"
              size="icon"
              className="h-20 w-20 rounded-full shadow-lg [&_svg]:size-8"
              aria-label="Hefja upptöku"
              title={disabledReason}
              disabled={disabled}
              onClick={handleStart}
            >
              <Mic />
            </Button>
          </TutorialAnchor>
          <p className="font-medium text-base text-foreground">Hefja upptöku</p>
        </div>
        <div className="hidden flex-col items-center md:flex">
          <div className="mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-slate-50">
            <Mic className="h-8 w-8 opacity-20" />
          </div>
          <p className="max-w-md text-base">{desktopPrompt}</p>
        </div>
      </div>
    </TutorialAnchor>
  );
};
